import { UseFormRegister, Merge, FieldError, UseFormWatch } from 'react-hook-form';
import i18n from '../../../i18n';
import { FormSectionType } from '../Generic/types';
import { SignUpFormType } from './types';

export const getSignUpFormFields = (
    register: UseFormRegister<SignUpFormType>, 
    errors: Merge<FieldError, SignUpFormType>, 
    watch: UseFormWatch<SignUpFormType>
):FormSectionType[] => ([
    {
        size: {
            md: 12,
            sm: 12
        },
        inputs: [
            {
                title: i18n.t("First Name"),
                input: register("firstName", { required: true }),
                error: errors.firstName,
                className:"login-input",
                placeholder: "First Name"
            },
            {
                title: i18n.t("Last Name"),
                input: register("lastName", { required: true }),
                error: errors.lastName,
                className:"login-input",
                placeholder: "Last Name"
            }
        ]
    },
    {
        size: {
            md: 12,
            sm: 12
        },
        inputs: [
            {
                title: i18n.t("Email"),
                input: register("email", { 
                    required: true ,
                    pattern: {
                        value: /^(?=.{1,254}$)(?=.{1,64}@)[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+(\.[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+)*@[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?(\.[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?)*$/,
                        message: "Invalid email address"
                      }
                }),
                error: errors.email,
                className:"login-input",
                placeholder: "Email"
            },
            {
                title: i18n.t("Company"),
                input: register("company", { required: true }),
                error: errors.company,
                className:"login-input",
                placeholder: "Company"
            },
            {
                title: i18n.t("Password"),
                input: register("password", { 
                    required: true,
                    pattern: {
                        value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d\w\W]{12,128}$/,
                        message: "Password must be at least 12 characters with at least one digit, lower case and upper case."
                      }
                }),
                error: errors.password,
                type:"password",
                className:"login-input",
                autoComplete: "new-password"
            },
            {
                title: i18n.t("Confirm Password"),
                input: register("confirmPassword", { 
                    required: true,
                    validate: (val: string) => {
                        if (watch("password") !== val) {
                            return i18n.t("Password does not match.").toString()
                        }
                        return true;
                    }
                }),
                error: errors.confirmPassword,
                type:"password",
                className:"login-input",
                autoComplete: "new-password"
            }
        ]
    }
])